import { useQuery } from '@tanstack/react-query'

import { adminDashboardApi } from '@/features/admin/api/dashboard.api'

export function useAdminDashboardQuery() {
  return useQuery({
    queryKey: ['admin', 'dashboard'],
    queryFn: adminDashboardApi.get,
    staleTime: 60_000,
  })
}
